import { SUBMIT_LOGIN, DELETE_LOGIN, LOGIN_ERROR } from '../actions/actionTypes';

const initialState = {
  localUser: {},
  error: null
}

export default function( state = initialState, action ) {
  switch( action.type ) {
    case SUBMIT_LOGIN: {
      const user = action.payload;
      return { ...state, localUser: { ...user }, error: null }
    }
    case LOGIN_ERROR: {
      const error = action.payload;
      return { ...state, error: error }
    }

    case DELETE_LOGIN: {
      return { ...state, localUser: {}, error: null }
    }
    default:
      return state;
  }
}
